module.exports = __webpack_public_path__ + "img/icon-coupon.a3a10aa2.svg";